// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatDroppableArea_root__lLoEr {
  position: relative;
}

.ChatDroppableArea_dropPlaceholder__lW2id {
  padding: 8px;
  background: white;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  -webkit-user-select: none;
          user-select: none;
  z-index: 15;
}
.ChatDroppableArea_dropPlaceholder__content__Fwk6W {
  text-align: center;
  position: relative;
  background: #FAFBFC;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8E8E93;
  font-size: 14px;
  font-weight: 400;
  cursor: copy;
}
.ChatDroppableArea_dropPlaceholder__content__Fwk6W:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #4778EE 70%, transparent 30%), linear-gradient(90deg, #4778EE 70%, transparent 30%), linear-gradient(0deg, #4778EE 70%, transparent 30%), linear-gradient(0deg, #4778EE 70%, transparent 30%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 8px 1px, 8px 1px, 1px 8px, 1px 8px;
  background-position: 0% 0%, 100% 100%, 0% 100%, 100% 0px;
  animation: ChatDroppableArea_dash__rHst5 20s linear infinite;
}

@keyframes ChatDroppableArea_dash__rHst5 {
  to {
    background-position: 100% 0%, 0% 100%, 0% 0%, 100% 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/DroppableArea/ChatDroppableArea.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EAGE,YAFU;EAGV,iBAAA;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,WAAA;AAHF;AAKE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AANJ;AAQI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EAEA,gOAAA;EAIA,yDAAA;EACA,mDAAA;EACA,wDAAA;EAEA,4DAAA;AAXN;;AAiBA;EACE;IACE,uDAAA;EAdF;AACF","sourcesContent":[".root {\n  position: relative;\n}\n\n.dropPlaceholder {\n  $padding: 8px;\n\n  padding: $padding;\n  background: white;\n\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  user-select: none;\n\n  z-index: 15;\n\n  &__content {\n    text-align: center;\n    position: relative;\n    background: #FAFBFC;\n\n    width: 100%;\n    height: 100%;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    color: #8E8E93;\n    font-size: 14px;\n    font-weight: 400;\n    cursor: copy;\n\n    &:before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n\n      background: linear-gradient(90deg, #4778EE 70%, transparent 30%),\n      linear-gradient(90deg, #4778EE 70%, transparent 30%),\n      linear-gradient(0deg, #4778EE 70%, transparent 30%),\n      linear-gradient(0deg, #4778EE 70%, transparent 30%);\n      background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n      background-size: 8px 1px, 8px 1px, 1px 8px, 1px 8px;\n      background-position: 0% 0%, 100% 100%, 0% 100%, 100% 0px;\n\n      animation: dash 20s linear infinite;\n    }\n  }\n}\n\n\n@keyframes dash {\n  to {\n    background-position: 100% 0%, 0% 100%, 0% 0%, 100% 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ChatDroppableArea_root__lLoEr`,
	"dropPlaceholder": `ChatDroppableArea_dropPlaceholder__lW2id`,
	"dropPlaceholder__content": `ChatDroppableArea_dropPlaceholder__content__Fwk6W`,
	"dash": `ChatDroppableArea_dash__rHst5`
};
export default ___CSS_LOADER_EXPORT___;
